import { render } from "./App.vue?vue&type=template&id=d5807970&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d5807970&scoped=true&lang=css"

import exportComponent from "/kaam/build/chevron/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5807970"]])

export default __exports__